<template>
  <ProductDetailPageBase>
    <ProductDetailPageLayout>
      <template #header> Skinny Banner </template>
      <template #breadcrumb> Breadcrumb </template>
      <template #out-of-stock> Out of Stock </template>
      <template #product-visuals> Gallery New </template>
      <template #product-aside-content>
        TitleDesktop<br />
        TitleMobile<br />
        TitleMobileAtc<br />
        Desktop FlashSalesSticker <br />
        Advertised Payment <br />
        Reassurance Items <br />
        Verified Refurbished Carousel <br />
        Seller Comment <br />
        Seller <br />
      </template>
      <template #content>
        Checkpoints Carousel<br />
        CustomizationFunnel <br />
        Recommendations <br />
        CMS block1 <br />
        Reviews <br />
        CMS block2 <br />
        Seo Links <br />
        CMS block3 <br />
        CMS block4 <br />
        Seo Tech specs <br />
        CMS block5 <br />
        Articles <br />
        AboutUs <br />
        Trust List <br />
        <!-- FIXME: How to manage the modal? -->
      </template>
    </ProductDetailPageLayout>
  </ProductDetailPageBase>
</template>

<script setup lang="ts">
import ProductDetailPageBase from '~/scopes/product-core/components/ProductDetailPageBase/ProductDetailPageBase.vue'
import ProductDetailPageLayout from '~/scopes/product-core/components/ProductDetailPageLayout/ProductDetailPageLayout.vue'
</script>
